<template>
  <section class="tag-section">
    <div class="background" />
    <div class="content-container">
      <div class="content content--bg">
        <h2 class="hg-title">{{ $t('youMightLikeThis') }}</h2>
      </div>
    </div>
    <client-only>
      <HgCardFlicking v-if="deals" class="related-flicking">
        <HgFlickingSlide
          v-for="deal in deals"
          :key="deal.id"
          class="hg-flicking-slide"
        >
          <DealCard :deal="deal" />
        </HgFlickingSlide>
      </HgCardFlicking>
    </client-only>
  </section>
</template>

<script>
import DealPathName from '@/mixins/DealPathName';
import DealCard from '@/components/deal/DealCard';

export default {
  components: {
    DealCard,
  },
  mixins: [DealPathName],
  props: {
    deals: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped lang="scss">
.tag-section {
  position: relative;
  margin-top: 2rem;
}

.related-flicking {
  position: relative;
  z-index: 10;
}

.bg-image {
  position: relative;
  width: 100%;
  padding: 1rem 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  margin-top: 2.5rem;
  padding-top: 5rem;
}

.hero-image--sm {
  min-height: 120px;
}

.hero-image--md {
  min-height: 400px;
}

.hero-image--lg {
  min-height: 600px;
}

.bg-image .image-wrapper {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 10;
}

.bg-image .content-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.bg-image .content {
  margin: 0 1rem;
  padding: 1rem;
  position: relative;
  z-index: 20;
  background: rgba(255 255 255 / 0.84);
  border-radius: 0.5rem;
}

.background {
  position: absolute;
  height: 60%;
  width: 100%;
  z-index: 1;
  top: 0;
  background-color: $teal-40;
}

.content {
  position: relative;
  z-index: 2;
  padding: 0 1.5rem;
  min-width: 220px;
  max-width: 720px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  h2 {
    margin: 0.5rem 0;
    border-radius: 0.5rem;
    margin-left: -0.5rem;

    padding-left: 0.5rem;
    padding-top: 1.5rem;
    padding-bottom: 0;
  }
}

.content--bg h2 {
  background-color: $teal-40;
}

@media screen and (min-width: 920px) {
  .background {
    width: 60%;
  }
}
</style>
